import React, { useContext } from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
} from 'next-share';

import { PageContext } from './PageProvider';

import TYPO from '../styles/typography';

import { ReactComponent as LinkedinIcon } from '../assets/social-icons/linkedin.svg';
import { ReactComponent as TwitterIcon } from '../assets/social-icons/twitter.svg';
import { ReactComponent as FacebookIcon } from '../assets/social-icons/facebook.svg';

import ENDPOINTS from '../../endpoints.json';

const Share = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 12px;
  ${TYPO.subheading}
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 24px;
`;

export default function ShareSection() {
  const { generic } = useContext(PageContext);
  const router = useRouter();
  const url = `${ENDPOINTS.website[process.env.BUILD_ENV]}${router.asPath}`;

  return (
    <Share>
      <span>{generic.blogPostSettings?.shareHeading}</span>
      <SocialIcons>
        <TwitterShareButton url={url}>
          <TwitterIcon width={24} height={24} />
        </TwitterShareButton>
        <LinkedinShareButton url={url}>
          <LinkedinIcon width={24} height={24} />
        </LinkedinShareButton>
        <FacebookShareButton url={url} hashtag={'#flow'}>
          <FacebookIcon width={24} height={24} />
        </FacebookShareButton>
      </SocialIcons>
    </Share>
  );
}
